import ViewCarouselIcon from '@material-design-icons/svg/filled/view_carousel.svg?react';

import { SpotlightDetail } from '../components/SpotlightDetail';
import { SpotlightList } from '../components/SpotlightList';
import type { AppSpotlightController } from '../useAppSpotlight';
import type { ExperimentPrefill, Spotlight } from '../types';

interface SpotlightsTabProps {
  controller: AppSpotlightController;
  selectedSpotlightId: string | null;
  isCreatingNew: boolean;
  onSelect: (id: string) => void;
  onSaved: (spotlight: Spotlight) => void;
  onRunExperiment: (prefill: ExperimentPrefill) => void;
  onDirtyChange: (dirty: boolean) => void;
}

export function SpotlightsTab({
  controller,
  selectedSpotlightId,
  isCreatingNew,
  onSelect,
  onSaved,
  onRunExperiment,
  onDirtyChange,
}: SpotlightsTabProps) {
  const selectedSpotlight =
    controller.spotlights.find((item) => item.id === selectedSpotlightId) ??
    null;

  return (
    <div className="grid gap-4 lg:grid-cols-[minmax(280px,0.8fr)_minmax(0,1.6fr)]">
      <div className="lg:max-h-[calc(100vh-220px)]">
        <SpotlightList
          spotlights={controller.spotlights}
          isLoading={controller.isLoading}
          selectedSpotlightId={selectedSpotlightId}
          isCreatingNew={isCreatingNew}
          onSelect={onSelect}
        />
      </div>

      <div>
        {isCreatingNew ? (
          <SpotlightDetail
            key="new"
            spotlight={null}
            controller={controller}
            onSaved={onSaved}
            onRunExperiment={onRunExperiment}
            onDirtyChange={onDirtyChange}
          />
        ) : selectedSpotlight ? (
          <SpotlightDetail
            key={selectedSpotlight.id}
            spotlight={selectedSpotlight}
            controller={controller}
            onSaved={onSaved}
            onRunExperiment={onRunExperiment}
            onDirtyChange={onDirtyChange}
          />
        ) : (
          <div className="flex h-full min-h-[320px] flex-col items-center justify-center rounded-xl border border-dashed border-neutral-800 px-6 py-16 text-center">
            <ViewCarouselIcon className="size-8 fill-current text-neutral-700" />
            <p className="mt-3 text-sm font-medium text-neutral-300">
              No spotlight selected
            </p>
            <p className="mt-1 max-w-xs text-sm text-neutral-500">
              Pick a spotlight from the list to curate it, or create a new one.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
